var _line, _line2, _line3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDrawer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 4,
    x2: 22,
    y2: 4,
    stroke: "url(#paint0_linear_408_1753)",
    strokeWidth: 4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 19,
    x2: 22,
    y2: 19,
    stroke: "url(#paint1_linear_408_1753)",
    strokeWidth: 4
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 12,
    x2: 22,
    y2: 12,
    stroke: "url(#paint2_linear_408_1753)",
    strokeWidth: 4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_408_1753",
    x1: 6.16667,
    y1: 2,
    x2: 16.5379,
    y2: 9.56234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#015A5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#066C6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#139B8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#28E7C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29E9C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_408_1753",
    x1: 6.16667,
    y1: 17,
    x2: 16.5379,
    y2: 24.5623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#015A5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#066C6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#139B8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#28E7C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29E9C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_408_1753",
    x1: 12.5,
    y1: 10,
    x2: 20.5,
    y2: 13.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#015A5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#066C6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#139B8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#28E7C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29E9C4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawer);
export default __webpack_public_path__ + "static/media/drawer.5f6486a4.svg";
export { ForwardRef as ReactComponent };